import React from "react";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import FloatingBackToTop from "@/components/nav/FloatingBackToTop";

const PublicLayout = ({ children }) => (
  <div className="flex min-h-screen flex-col bg-white">
    <Navbar />
    <main className="flex-1">{children}</main>
    <Footer />
    <FloatingBackToTop />
  </div>
);

export default PublicLayout;
